import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit, signal, viewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OfferpackService } from '@app/services/offerpack.service';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { MatSnackBar } from '@angular/material/snack-bar';
interface Customemail {
    currentCustomer: any;
    url?: string;
    name?: string;
    subject?: string;
    from: string;
    email?: string;
    cc?: string;
    text?: string;
    html?: string;
}

@Component({
    selector: 'app-customemail',
    templateUrl: './customemail.component.html',
    styleUrls: ['./customemail.component.scss'],
    standalone: false
})
export class CustomemailComponent implements OnInit {
    readonly colorpicker = viewChild<any>('colorpicker');
    readonly editor = viewChild<any>('editor');
    currentForeColor: string;
    currentFontSize: string = '3';
    currentUrl: string = '';
    isOpen: boolean = false;
    innerHTML: string = '';

    name: string = '';
    subject: string = '';
    from: string = '';
    email: string = '';
    cc: string = '';
    text: string = '';
    html: string = '';

    partnerForms: FormGroup;

    currentColor: string;
    currentBold: string;
    currentItalic: string;
    currentUnderline: string;
    currentColorbg: string;
    transparent: number;
    currentTitle: string = '';
    currentdivbg: string;

    // eslint-disable-next-line no-undef
    range: Range;
    // eslint-disable-next-line no-undef
    focusNode: Node;
    // eslint-disable-next-line no-undef
    currentSelection: Selection;
    loading = signal(true);
    currentRange: BehaviorSubject<any>;
    currentElement: BehaviorSubject<any>;
    destroyRef = inject(DestroyRef);
    constructor(
        public dialogRef: MatDialogRef<CustomemailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Customemail,
        private fb: FormBuilder,
        private offerpackService: OfferpackService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef,
    ) {
        this.currentRange = new BehaviorSubject(undefined);
        this.currentElement = new BehaviorSubject(undefined);
    }

    ngOnInit(): void {


        this.checkelement();
        if (this.data) {
            this.name = this.data.name;
            this.subject = this.data.subject;
            this.from = this.data.from;
            this.email = this.data.email;
            this.cc = this.data.cc;
            this.text = this.data.text;
            this.html = this.data.html;
            this.getModel();
            this.initPartnerforms();
        }
    }

    async initPartnerforms() {
        this.partnerForms = this.fb.group({
            name: new FormControl(this.name, [Validators.required, Validators.minLength(2)]),
            subject: new FormControl(this.subject, [Validators.required, Validators.minLength(2)]),
            from: new FormControl(this.from, [Validators.required, Validators.email]),
            email: new FormControl(this.email, [Validators.required, Validators.email]),
            cc: new FormControl(this.cc, [Validators.email]),
            floatLabel: 'auto',
        });
    }

    async getModel() {
        this.offerpackService.request({ email: this.data.currentCustomer?.email, partnerid: this.data.currentCustomer?.partnerid }, 'getemailmodel', this.data.currentCustomer?.token).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res?.html?.length > 0) {
                this.html = res.html?.replaceAll('{{url}}', this.data.url);
            } else {
                this.html = this.html?.replaceAll('{{url}}', this.data.url);
            }
            this.loading.set(false);
            this.cdr.detectChanges();
        });
    }

    async saveAsModel() {
        const dialogRef = this.dialog.open(ConfirmationComponent, {
            width: '500px',
            data: { message: 'Möchten Sie die als Vorlage speichern?', title: 'Speichern' }
        });

        dialogRef.afterClosed().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((result: any) => {
            if (result) {
                this.save();
            }
        });
    }

    async save() {
        const tmp_html = this.html?.replaceAll(this.data.url, '{{url}}');
        this.offerpackService.request({ html: tmp_html, email: this.data.currentCustomer?.email, partnerid: this.data.currentCustomer?.partnerid }, 'saveemailmodel', this.data.currentCustomer?.token).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res.success) {
                this.snackBar.open('Vorlage erfolgreich geändert', 'Schließen', {
                    panelClass: 'success',
                    duration: 3000,
                });
            } else {
                this.snackBar.open(res.error, 'Schließen', {
                    panelClass: 'error',
                    duration: 3000,
                });
            }
        });
    }

    async checkelement() {
        this.currentRange.asObservable().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((range) => {
            this.range = range;
        });

        this.currentElement.asObservable().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((element) => {
            if (element) {
                this.setRange(element);
            } else if (this.range) {
                this.selectRange();
            }
        });
    }

    setRange(element?: any) {
        if (this.range) {
            this.range.deleteContents();
            this.range.insertNode(element);
            element.focus();

            this.range.setStartBefore(element.firstChild);
        }
    }

    async onNoClick() {
        this.dialogRef.close();
    }

    async onOkClick() {
        const result = {
            name: this.partnerForms.value.name,
            subject: this.partnerForms.value.subject,
            from: this.partnerForms.value.from,
            email: this.partnerForms.value.email,
            cc: this.partnerForms.value.cc,
            text: this.partnerForms.value.text,
            html: this.html
        };
        this.dialogRef.close(result);
    }

    async openLinkMenu(value, ev) {
        ev.stopPropagation();
        this.isOpen = value;
        this.currentElement.next(null);
    }

    // eslint-disable-next-line no-undef
    getFirstAParent(node: Node): Node {
        // eslint-disable-next-line no-undef
        const elem = node as HTMLElement;
        if (node?.nodeName.toLocaleLowerCase() === 'div' && elem.id === 'myEditable') {
            return null;
        } else if (node?.nodeName.toLocaleLowerCase() === 'a') {
            return node;
        } else if (node?.parentNode) {
            return this.getFirstAParent(node.parentNode);
        } else {
            return null;
        }
    }

    selectRange() {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(this.range);
    }

    async setLink(ev) {
        ev && ev.stopPropagation();
        this.isOpen = false;
        if (this.currentUrl.length > 0) {
            this.currentUrl.replace('http://', 'https://');
            let url = ''
            if (this.currentUrl.startsWith('https://')) {
                url = this.currentUrl;
            } else {
                url = String('https://' + this.currentUrl);
            }
            if (this.range?.toString()?.length > 0) {
                const node_parent = this.getFirstAParent(this.focusNode);
                const node = this.getSelectionElement(this.focusNode);
                // eslint-disable-next-line no-undef
                const elem = node as HTMLElement;
                if (node_parent) {
                    // eslint-disable-next-line no-undef
                    const elem_parent = node_parent as HTMLElement;
                    elem_parent.setAttribute('href', url);

                    this.range.setStart(elem, 0);
                    this.selectRange();
                } else {
                    if (node.nodeName.toLocaleLowerCase() === 'div' && elem.id === 'myEditable') {
                        const element_a = document.createElement('a');
                        element_a.target = '_blank';
                        element_a.href = url;
                        element_a.innerHTML = this.range.toString();
                        this.range.deleteContents();
                        this.range.insertNode(element_a);

                        this.range.setStartBefore(element_a);
                        this.selectRange();
                    } else if (node.nodeName.toLocaleLowerCase() !== 'a') {
                        // this.restoreSelection(this.range);
                        const element_a = document.createElement('a');
                        element_a.target = '_blank';
                        element_a.href = url;

                        const fragment = this.range.extractContents();

                        const theText = document.createTextNode(fragment.textContent);
                        element_a.appendChild(theText);

                        // if Text node
                        if (this.focusNode.nodeType === 3) {
                            this.range.insertNode(element_a);
                            this.range.setStart(element_a.firstChild, 0);
                            this.range.setEndAfter(element_a.firstChild);
                            this.selectRange();
                        } else {
                            elem.append(element_a);
                            this.range.setStart(element_a.firstChild, 0);
                            this.range.setEndAfter(element_a.firstChild);
                            this.selectRange();
                        }
                    } else if (node.nodeName.toLocaleLowerCase() === 'a') {
                        elem.setAttribute('href', url);
                        this.range.deleteContents();
                        this.range.insertNode(elem);

                        this.range.setStart(elem, 0);
                        this.selectRange();
                    }
                }
            }
        }
    }

    async setStyle(type) {
        setTimeout(() => {
            this.restoreSelection(this.range);
            switch (type) {
                case 'bold':
                    this.insertStrong();
                    break;
                case 'underline':
                    this.insertUnderline();
                    break;
                case 'italic':
                    this.insertItalic();
                    break;
                case 'justifyFull':
                    this.insertJustify('justify');
                    break;
                case 'justifyLeft':
                    this.insertJustify('left');
                    break;
                case 'justifyCenter':
                    this.insertJustify('center');
                    break;
                case 'justifyRight':
                    this.insertJustify('right');
                    break;
                case 'insertOrderedList':
                    this.insertOrder('ol');
                    break;
                case 'insertList':
                    this.insertOrder('ul');
                    break;
                default:
                    break;
            }
        }, 100);
    }

    async insertOrder(wrap) {
        if (this.range?.toString()?.length > 0) {
            var el = document.createElement('li');
            try {
                this.range.surroundContents(el);
                const w = document.createElement(wrap);
                this.range.surroundContents(w);
            } catch (error) {
                // eslint-disable-next-line no-undef
                alert('Nicht möglich');
            }
        }
    }

    async insertJustify(position) {
        if (this.range.toString()?.length > 0) {
            const node = this.getSelectionElement(this.focusNode);
            const firstParentDiv = this.getFirstDivParent(node);
            // eslint-disable-next-line no-undef
            const elem_div = firstParentDiv as HTMLElement;
            // eslint-disable-next-line no-undef
            const elem = node as HTMLElement;
            if (firstParentDiv.nodeName.toLocaleLowerCase() === 'div' && elem_div.id !== 'myEditable') {
                if (elem_div.style.textAlign !== position) {
                    elem_div.style.textAlign = position;
                }
            } else if (firstParentDiv.nodeName.toLocaleLowerCase() === 'div' && elem_div.id === 'myEditable') {
                const div = document.createElement('div');
                div.style.textAlign = position;
                if (node.nodeName.toLocaleLowerCase() === 'div' && elem.id === 'myEditable') {
                    div.innerHTML = elem.innerHTML;
                } else {
                    div.innerHTML = elem.outerHTML;
                    elem.parentNode.removeChild(elem);
                }
                this.currentElement.next(div);
            } else {
                const div = document.createElement('div');
                div.style.textAlign = position;
                div.appendChild(firstParentDiv);
                this.range.deleteContents();
                this.range.insertNode(div);

                this.range.setStart(div.firstChild, 0);
            }
        }
    }

    async insertItalic() {
        if (this.range?.toString()?.length > 0) {
            const node = this.getSelectionElement(this.focusNode);
            // eslint-disable-next-line no-undef
            const elem = node as HTMLElement;
            if ((node.nodeName.toLocaleLowerCase() === 'div' && elem.id === 'myEditable') || node.textContent !== this.range.toString()) {
                const italic = document.createElement('span');
                italic.style.fontStyle = 'italic';
                this.currentItalic = 'italic';
                italic.innerHTML = this.currentSelection?.toString();
                this.currentElement.next(italic);
            } else {
                if (elem.style.fontStyle === 'italic') {
                    elem.style.fontStyle = '';
                    this.currentItalic = '';
                } else {
                    elem.style.fontStyle = 'italic';
                    this.currentItalic = 'italic';
                }
            }
        }
    }

    async insertUnderline() {
        if (this.range?.toString()?.length > 0) {
            const node = this.getSelectionElement(this.focusNode);
            // eslint-disable-next-line no-undef
            const elem = node as HTMLElement;
            if ((node.nodeName.toLocaleLowerCase() === 'div' && elem.id === 'myEditable') || node.textContent !== this.range.toString()) {
                const underline = document.createElement('span');
                underline.style.setProperty('text-decoration', 'underline', 'important');
                this.currentUnderline = 'underline';
                underline.innerHTML = this.currentSelection.toString();
                this.currentElement.next(underline);
            } else {
                if (elem.style.textDecoration === 'underline') {
                    elem.style.textDecoration = '';
                    this.currentUnderline = '';
                } else {
                    elem.style.setProperty('text-decoration', 'underline', 'important');
                    this.currentUnderline = 'underline';
                }
            }
        }
    }

    async insertStrong() {
        if (this.range?.toString()?.length > 0) {
            const node = this.getSelectionElement(this.focusNode);
            // eslint-disable-next-line no-undef
            const elem = node as HTMLElement;
            if ((node.nodeName.toLocaleLowerCase() === 'div' && elem.id === 'myEditable') || node.textContent !== this.range.toString()) {
                const strong = document.createElement('span');
                strong.style.fontWeight = 'bold';
                this.currentBold = 'bold';
                strong.innerHTML = this.currentSelection.toString();
                this.currentElement.next(strong);
            } else {
                if (elem.style.fontWeight === 'bold') {
                    elem.style.fontWeight = '';
                    this.currentBold = '';
                } else {
                    elem.style.fontWeight = 'bold';
                    this.currentBold = 'bold';
                }
            }
        }
    }

    resetPropertis() {
        this.currentTitle = '';
        this.currentFontSize = '';
        this.currentColor = '';
        this.currentColorbg = '';
        this.currentBold = '';
        this.currentItalic = '';
        this.currentUnderline = '';
        this.currentUrl = '';
    }

    // eslint-disable-next-line no-undef
    getSelectionElement(node: Node): Node {
        if (node.nodeType !== 3) {
            return node;
        } else {
            return node.parentNode;
        }
    }

    // eslint-disable-next-line no-undef
    getFirstDivParent(node: Node): Node {
        if (node?.nodeName.toLocaleLowerCase() === 'div') {
            return node;
        } else if (node?.parentNode) {
            return this.getFirstDivParent(node.parentNode);
        } else {
            return node;
        }
    }

    async getPropertis(node) {
        if (node && window) {
            const parent = this.getSelectionElement(node);
            // eslint-disable-next-line no-undef
            const elem = parent as HTMLElement;
            this.resetPropertis();
            const computid = window.getComputedStyle(elem);
            if (elem?.style?.fontSize?.length > 0) {
                this.currentFontSize = elem.style.fontSize;
            } else {
                this.currentFontSize = computid.fontSize;
            }

            if (elem?.style?.color?.length > 0) {
                this.currentColor = elem.style.color;
            }

            if (elem?.style?.backgroundColor?.length > 0) {
                this.currentColorbg = elem.style.backgroundColor;
            } else if (computid.backgroundColor !== 'rgba(0, 0, 0, 0)') {
                this.currentColorbg = computid.backgroundColor;
            }

            if (elem?.style?.fontWeight?.length > 0) {
                this.currentBold = elem.style.fontWeight;
            } else {
                this.currentBold = computid.fontWeight;
            }

            if (elem?.style?.fontStyle?.length > 0) {
                this.currentItalic = elem.style.fontStyle;
            } else {
                this.currentItalic = computid.fontStyle;
            }

            if (elem?.style?.textDecoration?.length > 0) {
                this.currentUnderline = elem.style.textDecoration;
            } else {
                this.currentUnderline = computid.textDecoration;
            }
            this.checkElemenA(parent);
            switch (parent.nodeName.toLocaleLowerCase()) {
                case 'h1':
                case 'h2':
                case 'h3':
                case 'h4':
                case 'h5':
                case 'h6':
                    // this.currentFontSize = '';
                    this.currentTitle = parent.nodeName.toLocaleLowerCase();
                    break;

                default:
                    break;
            }
        }
    }

    // eslint-disable-next-line no-undef
    checkElemenA(node: Node): void {
        if (node.nodeName.toLocaleLowerCase() === 'a') {
            // eslint-disable-next-line no-undef
            const elem = node as HTMLElement;
            this.currentUrl = elem.getAttribute('href');
        } else if (node.parentNode) {
            this.checkElemenA(node.parentNode);
        }
    }

    openColorPicker() {
        this.initColorComponent();
        const colorpicker = this.colorpicker();
        if (colorpicker.nativeElement) {
            colorpicker.nativeElement.click();
        }
    }

    async setFontSize(size) {
        if (this.range?.toString()?.length > 0) {
            const node = this.getSelectionElement(this.focusNode);
            // eslint-disable-next-line no-undef
            const elem = node as HTMLElement;
            if ((node.nodeName.toLocaleLowerCase() === 'div' && elem.id === 'myEditable') || node.textContent !== this.range.toString()) {
                const fsize = document.createElement('span');
                fsize.style.fontSize = size;
                fsize.innerHTML = this.range.toString();
                this.currentElement.next(fsize);
            } else {
                elem.style.fontSize = size;
            }
        }
    }

    initColorComponent() {
        if (this.range?.toString()?.length > 0) {
            const node = this.getSelectionElement(this.focusNode);
            // eslint-disable-next-line no-undef
            const elem = node as HTMLElement;
            if ((node.nodeName.toLocaleLowerCase() === 'div' && elem.id === 'myEditable') || node.textContent !== this.range.toString()) {
                const col = document.createElement('span');
                col.innerHTML = this.range.toString();
                this.setRange(col);
                this.protect(null);
            }
        }
    }

    setColor(color) {
        const node = this.getSelectionElement(this.focusNode);
        // eslint-disable-next-line no-undef
        const elem = node as HTMLElement;
        elem.style.color = color;
    }

    protect(ev) {
        ev && ev.stopPropagation();
        if (window && window.getSelection().rangeCount > 0) {
            this.currentSelection = window.getSelection();
            this.focusNode = window.getSelection().anchorNode;
            this.currentRange.next(window.getSelection().getRangeAt(0));
        }
        return setTimeout(() => { }, 100);
    }

    async onTitleChange(hed) {
        if (this.range?.toString()?.length > 0 && hed?.length > 0) {
            let node = this.focusNode;
            if (
                node.parentNode.nodeName.toLocaleLowerCase() === 'h1' ||
                node.parentNode.nodeName.toLocaleLowerCase() === 'h2' ||
                node.parentNode.nodeName.toLocaleLowerCase() === 'h3' ||
                node.parentNode.nodeName.toLocaleLowerCase() === 'h4' ||
                node.parentNode.nodeName.toLocaleLowerCase() === 'h5' ||
                node.parentNode.nodeName.toLocaleLowerCase() === 'h6'
            ) {
                node = node.parentNode;
            }
            // eslint-disable-next-line no-undef
            const elem = node as HTMLElement;
            const hedelem = document.createElement(hed);
            hedelem.style.padding = '0px';
            hedelem.style.margin = '0px';
            if (node.nodeType === 3) {
                hedelem.innerHTML = node.textContent;
            } else {
                hedelem.innerHTML = elem.innerHTML;
            }
            elem.parentNode.removeChild(elem);
            this.currentElement.next(hedelem);
        }
    }

    async checkEditor(ev) {
        ev.stopPropagation();
        if (window) {
            const selection = window.getSelection();
            this.resetPropertis();
            this.getPropertis(selection.focusNode);
        }
    }

    insertText(text) {
        const textNode = document.createTextNode(text);
        this.range.deleteContents();
        this.range.insertNode(textNode);
        this.range.selectNodeContents(textNode);
        this.range.collapse(false);

        if (window) {
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(this.range);
        }
    };

    restoreSelection(range) {
        if (range) {
            if (window && window.getSelection) {
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    }
}
